import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import DataTable from '../../components/admin/DataTable';
import ImageUpload from '../../components/admin/ImageUpload';

const CertificationsManagement = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    title_ar: '', type: 'certification', organization_ar: '', image: '', logo: '', date: '', is_published: true
  });
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/certifications/all`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      });
      setItems(await response.json());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editing ? `${BACKEND_URL}/api/certifications/${editing.id}` : `${BACKEND_URL}/api/certifications/`;
      const response = await fetch(url, {
        method: editing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        fetchItems();
        resetForm();
        alert('تم الحفظ بنجاح');
      }
    } catch (error) {
      alert('حدث خطأ');
    }
  };

  const resetForm = () => {
    setFormData({ title_ar: '', type: 'certification', organization_ar: '', image: '', logo: '', date: '', is_published: true });
    setEditing(null);
    setShowForm(false);
  };

  const columns = [
    { header: 'العنوان', accessor: 'title_ar' },
    { header: 'النوع', render: (row) => row.type === 'certification' ? 'شهادة' : row.type === 'membership' ? 'عضوية' : 'اتفاقية' },
    { header: 'الجهة', accessor: 'organization_ar' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-[#0F388E]">الشهادات والعضويات والاتفاقيات</h1>
        <Button onClick={() => setShowForm(!showForm)} className="bg-[#0F388E]">
          <Plus className="ml-2" />إضافة
        </Button>
      </div>

      {showForm && (
        <Card>
          <CardHeader><CardTitle>{editing ? 'تعديل' : 'إضافة'}</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <select value={formData.type} onChange={(e) => setFormData({...formData, type: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg">
                <option value="certification">شهادة</option>
                <option value="membership">عضوية</option>
                <option value="agreement">اتفاقية</option>
              </select>
              <input type="text" placeholder="العنوان *" value={formData.title_ar}
                onChange={(e) => setFormData({...formData, title_ar: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" required />
              <input type="text" placeholder="الجهة *" value={formData.organization_ar}
                onChange={(e) => setFormData({...formData, organization_ar: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" required />
              <input type="date" placeholder="التاريخ" value={formData.date}
                onChange={(e) => setFormData({...formData, date: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" />
              <ImageUpload label="الصورة/الشهادة" value={formData.image}
                onChange={(v) => setFormData({...formData, image: v})} />
              <div className="flex gap-3 justify-end">
                <Button type="button" variant="outline" onClick={resetForm}>إلغاء</Button>
                <Button type="submit">حفظ</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent className="pt-6">
          <DataTable columns={columns} data={items}
            onEdit={(item) => { setEditing(item); setFormData(item); setShowForm(true); }}
            onDelete={async (item) => {
              await fetch(`${BACKEND_URL}/api/certifications/${item.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
              });
              fetchItems();
            }}
            loading={loading} />
        </CardContent>
      </Card>
    </div>
  );
};

export default CertificationsManagement;
